<template>
  <div>
    <v-row justify="space-between" class="header-container">
      <v-col md="6" :cols="12" class="pa-0">
        <div class="checkname-header">Live notification</div></v-col
      >
      <v-col md="6" :cols="12" class="pa-0">
        <div class="tab-header-text text-right">
          <v-btn
            @click="initialize"
            class="pl-5 pr-5 xs-full-width font-weight-light btn-refresh"
            elevation="0"
            color="#d9d9d9"
            outlined
          >
            <v-icon left>mdi-cached</v-icon>
            <span class="text-refresh">{{
              $vuetify.lang.t('$vuetify.courseManagement.filterBar.refresh')
            }}</span>
          </v-btn>

          <v-btn
            @click="openPushNoticeDialog('LIVE')"
            elevation="0"
            class="
              pl-5
              pr-5
              xs-full-width
              font-weight-light
              button-primary
              white--text
            "
          >
            <v-icon left>mdi-plus</v-icon>
            New Notification
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div
      v-if="listNotificationLive == null || listNotificationLive.length == 0"
    >
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px"
          >mdi-bell-ring</v-icon
        >
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีรายการให้แสดง</div>
      </v-row>
    </div>
    <div
      v-else
      v-for="(item, index) in listNotificationLive"
      :key="item._id"
      class="checkname-container"
    >
      <div class="checkname-icon">
        <v-img
          :src="item.image"
          class="my-2 rounded-card"
          width="80"
          aspect-ratio="1.7"
        >
          <template v-slot:placeholder>
            <v-row class="ma-0" align="center" justify="center">
              <v-icon v-if="!item.image" class="mx-auto" elevation="3" size="50"
                >mdi-image-outline</v-icon
              >
            </v-row>
          </template>
        </v-img>
      </div>
      <div class="checkname-action">
        <v-row class="ma-0 justify-content-center">
          <span class="checkname-link">
            ส่งแล้ว: {{ item.timesend | moment('HH:mm') }} น.</span
          >
        </v-row>
      </div>
      <div class="checkname-detail">
        <v-row class="ma-0">
          <span class="checkname-name">
            ส่งแจ้งเตือนครั้งที่
            {{ countSend - index - (currentPage - 1) * params.limit }}:
            <!-- {{ (currentPage - 1) * params.limit - (countSend - 1) }}: -->
            {{ item.title }}</span
          >
        </v-row>
        <v-row class="ma-0">
          <span class="subtitle-1">
            รายละเอียด: {{ item.body ? item.body : '-' }}</span
          >
        </v-row>
      </div>
    </div>

    <v-pagination
      v-if="listNotificationLive != null && listNotificationLive.length > 0"
      v-model="currentPage"
      class="pagination-align-right justify-flex-end"
      :length="pageCount"
      @input="changePage"
      :total-visible="10"
    ></v-pagination>

    <notification-dialog
      :openDialogPushNotice.sync="isPushNoticeDialogOpen"
      :closePushNoticeDialog.sync="closePushNoticeDialog"
      :typeNotice.sync="typeNotice"
      :courseId.sync="courseId"
      :subId.sync="liveId"
      :titleNotice.sync="titleNotice"
      :messageNotice.sync="messageNotice"
      :from.sync="from"
      :timeSendNotice.sync="timeSendNotice"
      :targetNotice.sync="targetSend"
      :platformNotice.sync="platform"
      :usergroup.sync="usergroup"
      :alertNotice.sync="alertNotice"
      :stausNotice.sync="schedule"
      :liveStartTime.sync="liveStartTime"
      :liveEndTime.sync="liveEndTime"
    ></notification-dialog>
  </div>
</template>
<script>
import notificationDialog from '@/views/course/dialog/pushNotificationDialog.vue';
import { getListNoticeLive } from '@/service/notification/notification';
export default {
  props: {
    courseId: {
      type: String,
    },
    liveId: {
      type: String,
    },
    liveStartTime: {
      type: Number,
    },
    liveEndTime: {
      type: Number,
    },
  },
  name: 'liveNotification',
  components: {
    notificationDialog,
  },
  data: () => ({
    // views
    isPushNoticeDialogOpen: false,

    // data
    courseList: [],
    from: 'live_dashboard',
    titleNotice: '',
    messageNotice: '',
    imageNotice: '',
    timeSendNotice: 0,
    alertNotice: null,
    targetSend: 'course-usergroup',
    platform: 'all',
    schedule: 'sendnow',

    listNotificationLive: [],
    currentPage: 1,
    pageCount: 1,
    countSend: 1,
  }),
  async mounted() {
    await this.initialize();
  },

  methods: {
    async initialize() {
      this.params = {
        // search: this.searchCategory,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        // active: "null",
        company: this.$store.state.company._id,
        idlivestreamv2: this.liveId,
      };
      await this.getListNoticeLive();
    },
    async getListNoticeLive() {
      let result = await getListNoticeLive(this.params);
      this.listNotificationLive = result.data;

      this.pageCount = result.maxPage;
      this.countSend = result.count;
    },
    async changePage(page) {
      this.params.page = page;
      await this.getListNoticeLive();
    },
    openPushNoticeDialog(type) {
      this.typeNotice = type;
      this.isPushNoticeDialogOpen = true;
    },
    closePushNoticeDialog() {
      this.typeNotice = '';
      this.noticeId = '';
      this.isPushNoticeDialogOpen = false;
      this.initialize();
    },
  },
};
</script>
<style lang="scss" scoped>
.rounded-card {
  border-radius: 8px;
  border-color: black;
}
.img-list {
  height: 60px;
  width: 120px;
  border-radius: inherit;
}
.checkname-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.checkname-icon {
  float: left;
  width: 100px;
  height: 60px;
}
.checkname-action {
  float: right;
  //   width: 85px;
  align-self: center;
}
.checkname-detail {
  margin: 0 auto;
  // width: calc(100% - 85px - 37px);
  line-break: anywhere;
}
.checkname-container {
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.checkname-link {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.header-container {
  margin: 0px;
  margin-bottom: 30px;
}
.checkname-name {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 6px;
}
</style>
